export const pageSizes = [5, 10, 15, 20, 30, 50, 150, 300, 1000];
export const defaultPageSize = 20;
export const defaultOrdering = [{} as any];
